
























































import Vue from "vue";
import { Component, Ref } from "vue-property-decorator";
import User from "@/models/user";
import IProfile from "@/interfaces/profile";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState("authentication", ["user"]),
  },
})
export default class Profile extends Vue {
  user!: User;

  loading = false;

  profileForm: any = {
    firstName: "",
    lastName: "",
    companyName: "",
  };

  rules: any = {
    firstName: {
      required: true,
      message: "Your first name is required",
      trigger: ["blur"],
    },
    lastName: {
      required: true,
      message: "Your last name is required",
      trigger: ["blur"],
    },
  };

  @Ref("profileFormRef")
  profileFormRef!: any;

  created() {
    this.profileForm.firstName = this.user.firstName;
    this.profileForm.lastName = this.user.lastName;
    this.profileForm.companyName = this.user.companyName;
  }

  updateProfile() {
    this.profileFormRef.validate((valid: boolean) => {
      if (valid) {
        this.loading = true;

        const model: IProfile = {
          firstName: this.profileForm.firstName,
          lastName: this.profileForm.lastName,
          companyName: this.profileForm.companyName,
          userId: this.user.id,
        };

        this.$store
          .dispatch("authentication/updateUser", model)
          .then(() => {
            this.loading = false;
            this.$message({
              message: "Your profile has been updated.",
              type: "success",
            });
          })
          .catch(() => {
            this.loading = false;
            this.$message({
              message:
                "Something went wrong while updating your profile. Please try again.",
              type: "error",
            });
          });
      }
    });
  }
}
